export default "__VITE_ASSET__BtMuJlED__"